import { useTranslation } from "react-i18next";

export const useI18blogTabs = () => {
  const { t } = useTranslation();

  const tabs = [
    {
      name: "all",
      title: t("blog.tabs.title.1"),
    },
    {
      name: "vpn",
      title: t("blog.tabs.title.2"),
    },
    {
      name: "artificial",
      title: t("blog.tabs.title.3"),
    },
    {
      name: "security",
      title: t("blog.tabs.title.4"),
    },
    {
      name: "placeholder",
      title: t("blog.tabs.title.5"),
    },
    {
      name: "proxy",
      title: t("blog.tabs.title.6"),
    },
    {
      name: "headers",
      title: t("blog.tabs.title.7"),
    },
    {
      name: "attributes",
      title: t("blog.tabs.title.8"),
    },
  ];

  return { tabs };
};
